export default __webpack_public_path__ + "static/media/bots.9778b956.svg";